import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./screens/intro/Home";
import { AllLayout } from "./screens/AllLayout";
//Login
import Login from "./screens/login/Login";

// setting
import IntroSettings from "./screens/setting/IntroSettings";

// store & order
import OrderMain from "./screens/order/OrderMain";
import OrderHistory from "./screens/order/OrderHistory";
import OrderPayment from "./screens/order/OrderPayment";

// map
// import MainMap from "./screens/map/MainMap";
import MainMap from "./screens/map/MainMapV2";

// components
import PaymentPassword from "./components/PaymentPassword";
import OrderComplete from "./screens/order/OrderComplete";
import FavoriteStore from "./screens/order/FavoriteStore";
import ShareSetting from "./screens/login/ShareSetting";
import PasswordTypeSetting from "./screens/setting/PasswordTypeSetting";
import PasswordSetting from "./screens/login/PasswordSetting";
import UserList from "./screens/login/UserList";
import Settings from "./screens/setting/Settings";
// import Recorder from "./components/ccOS/Recorder";
import Recorder from "./components/Recording/Recorder";
import { BackLayout } from "./screens/BackLayout";

const App = () => {
  useEffect(() => {}, []);

  return (
    <Routes>
      <Route path="/" element={<AllLayout />}>
        <Route index element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />

        <Route element={<BackLayout />}>
          {/* login */}
          <Route path="/login/:car_uuid" element={<Login />} />
          <Route path="/login" element={<Login />} />

          {/* setting */}
          <Route path="/setting" element={<Settings />} />

          {/* order */}
          <Route path="/order/main" element={<OrderMain />} />
          <Route path="/order/favorite" element={<FavoriteStore />} />
          <Route path="/order/history" element={<OrderHistory />} />
          <Route path="/order/payment" element={<OrderPayment />} />
          <Route path="/order/complete" element={<OrderComplete />} />

          {/* map */}
          <Route path="/map" element={<MainMap />} />

          {/* components */}
          <Route path="/payment/password" element={<PaymentPassword />} />

          {/* chat */}
          {/* <Route path="/chat" element={<Recorder />} /> */}
          <Route path="/chat" element={<Recorder />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default App;
